export function imageFileValidator(
  input?: File,
  isRequired?: boolean
): string | boolean {
  if (!input) {
    return true;
  }
  if (RegExp("image/*").test(input.type)) {
    if (input.size > 2 * 1024 * 1024) {
      return "File size must be less than 2MB";
    }
    return true;
  } else {
    return "Only images allowed";
  }
}
export function emailValidator(
  email: string,
  isRequired?: boolean
): boolean | string {
  if (isRequired === false) {
    if (!email) {
      return true;
    }
  }
  const emailPattern: RegExp =
    /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  if (emailPattern.test(email)) {
    return true;
  } else {
    return "Enter a valid email";
  }
}

export function nameValidator(name: string): boolean | string {
  if (name.length < 1) {
    return "Field is required";
  }
  const namePattern: RegExp = /^[a-zA-Z\s]+$/;
  if (namePattern.test(name)) {
    return true;
  } else {
    return "No special characters or numbers allowed";
  }
}

export function passwordValidator(password: string): boolean | string {
  if (password.length < 8) {
    return "Password should be atleast 8 characters";
  } else {
    return true;
  }
}

export function required(input: any): string | boolean {
  if (input === null || input === undefined) {
    return "Field is Required";
  }
  if (input.length < 1) {
    return "Field is Required";
  } else {
    return true;
  }
}

export function positiveNumberOnly(input: string): string | boolean {
  let num = parseFloat(input);
  if (!isNaN(num) && num > 0) {
    return true;
  } else {
    return "Must be greater than 0";
  }
}

export function textAreaValidator(input: string): string | boolean {
  if (input.length < 30) {
    return "Must be atleast 30 characters";
  } else if (input.length > 300) {
    return "Must be under 300 characters";
  } else {
    return true;
  }
}

export function pdfFileValidator(input: File[]): string | boolean {
  if (input.length === 0) {
    // Incase of not required, if required than go with combo of required and this validator
    return true;
  }
  if (input[0].type === "application/pdf") {
    // console.log(input[0]);
    if (input[0].size > 1000000) {
      return "File size must be less than 1mb";
    }
    return true;
  } else {
    return "Only pdf files allowed";
  }
}

export function phoneNumberValidator(phoneNumber: string): boolean | string {
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
  const isValidLength = numericPhoneNumber.length === 10;
  const hasCorrectCountryCode = numericPhoneNumber.startsWith("45");
  const isValidFormat = /^\d+$/.test(numericPhoneNumber);
  if (isValidLength && hasCorrectCountryCode && isValidFormat) {
    return true;
  } else {
    return "Enter a Valid Phone Number";
  }
}
